export enum AccountManagementViews {
    SUBSCRIPTION = 'subscription',
    OUTREACH_SETTING = 'outreach-settings',
    ORGANIZATION_SETTINGS = 'organization-settings',
    PROFILE = 'profile',
    USERS = 'users',
    OUTREACH_ACCOUNTS = 'outreach-accounts',
    OUTREACH_SETTINGS = 'outreach-settings',
}
